import { Injectable } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';


@Injectable()
export class SideNavService {
	private drawer: MatDrawer;

setDrawer(drawer: MatDrawer) {
    this.drawer = drawer;
}

toggle(): void {
    this.drawer.toggle();
}
}